// Auto-generated lightweight class for CatalogNode
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { CatalogNodeReadAPI, CatalogNodeWriteAPI, CatalogNodeReadAPISchema, CatalogNodeWriteAPISchema } from '../types/catalognode';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, CatalogAt, IslandHoldsPin } from '../../relationships/relationship';

import { SecurityScope } from './securityscope';
import { IslandPin } from '../../rflp/api/islandpin';



export interface CatalogNode extends Partial<CatalogNodeReadAPI> {}
export class CatalogNode extends NeoNodeBase<CatalogNodeReadAPI, CatalogNodeWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "CatalogNode";
  static readonly readSchema = CatalogNodeReadAPISchema;
  static readonly writeSchema = CatalogNodeWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    catalog_scope: { target: "SecurityScope", cardinality: "one", isParent: false, relClass: "CatalogAt", direction: "out" },
    island_pins: { target: "IslandPin", cardinality: "many", isParent: false, relClass: "IslandHoldsPin", direction: "out" },
  };

  protected get modelName(): string {
    return 'CatalogNode';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return CatalogNode.label;
  }


  constructor(data: Partial<CatalogNodeWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: CatalogNodeReadAPI, loadContext?: Record<string, any>): CatalogNode {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { catalog_scope, security_scope, island_pins, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = CatalogNodeReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, catalog_scope: catalog_scope, security_scope: security_scope, island_pins: island_pins };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return CatalogNode.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'catalog_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadManyRelationship(processed, 'island_pins', 'IslandPin', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new CatalogNode(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'catalog_scope' - Python ORM style (cached)
  get catalog_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('catalog_scope', () => {
      return new RelationshipManager(this, 'catalog_scope', 'one', CatalogAt as typeof Relationship);
    });
  }

  // Relationship manager for 'island_pins' - Python ORM style (cached)
  get island_pins(): RelationshipManager<this, IslandPin> {
    return this.getOrCreateRelationshipManager('island_pins', () => {
      return new RelationshipManager(this, 'island_pins', 'many', IslandHoldsPin as typeof Relationship);
    });
  }

}
